import React from 'react'
import PropTypes from 'prop-types'
import FileIcon from '../../ui/icons/FileIcon'
import EyeIcon from '../../ui/icons/EyeIcon'
import Tooltip from '../../ui/Tooltip'
import { formatDateTime } from '../../../utils/dateHelpers'

const VARIABLE_NAME = 'variable_name'
const ATTACHMENT_URL = 'attachment_url'
const ATTACHMENT_FILENAME = 'attachment_filename'
const ATTACHMENT_CREATED_AT = 'attachment_created_at'

const CARD_CLASS = 'tw:flex tw:lg:w-1/2 tw:items-stretch tw:gap-3 tw:overflow-hidden tw:rounded-lg! '
  + 'tw:border tw:border-solid tw:border-gray-300 tw:bg-white tw:pr-3'
const ICON_BOX_CLASS = 'tw:flex tw:w-12 tw:shrink-0 tw:items-center tw:justify-center '
  + 'tw:border-r tw:border-solid tw:border-gray-300 tw:text-2xl! tw:text-gray-600'
const EYE_CLASS = 'tw:flex tw:size-10 tw:shrink-0 tw:items-center tw:justify-center '
  + 'tw:text-2xl! tw:text-gray-600!'

const PdfMarkField = ({ mark }) => {
  const { question } = mark
  const url = question[ATTACHMENT_URL]
  const dynamic = Boolean(question[VARIABLE_NAME])
  const createdAt = question[ATTACHMENT_CREATED_AT]
  const variableMessage = 'Aucun fichier PDF disponible pour cette variable'
  const questionMessage = 'Aucun fichier PDF attaché à cette question'

  if (!url) {
    return (
      <div className="tw:text-sm tw:text-gray-600">
        {dynamic ? variableMessage : questionMessage}
      </div>
    )
  }

  return (
    <div className={CARD_CLASS}>
      <div className={ICON_BOX_CLASS}>
        <FileIcon />
      </div>
      <div className="tw:flex tw:flex-1 tw:min-w-0 tw:flex-col tw:justify-center tw:gap-0.5 tw:py-2">
        <span className="tw:truncate tw:text-sm tw:text-gray-950">
          {question[ATTACHMENT_FILENAME]}
        </span>
        {createdAt ? (
          <span className="tw:text-sm tw:text-gray-600">
            {`Importé le ${formatDateTime(createdAt)}`}
          </span>
        ) : null}
      </div>
      <Tooltip className="tw:flex tw:items-center tw:shrink-0 tw:self-center" content="Ouvrir">
        <a
          aria-label="Ouvrir le PDF"
          className={EYE_CLASS}
          href={url}
          rel="noopener noreferrer"
          target="_blank"
        >
          <EyeIcon />
        </a>
      </Tooltip>
    </div>
  )
}

PdfMarkField.propTypes = {
  mark: PropTypes.shape({
    question: PropTypes.shape({
      [ATTACHMENT_CREATED_AT]: PropTypes.string,
      [ATTACHMENT_FILENAME]: PropTypes.string,
      [ATTACHMENT_URL]: PropTypes.string,
      [VARIABLE_NAME]: PropTypes.string
    })
  }).isRequired
}

export default PdfMarkField
